/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IDeleteInternalRegulationObligationRuleMutationVariables = Types.Exact<{
  input: Types.IDeleteInternalRegulationObligationRuleInput;
}>;

export type IDeleteInternalRegulationObligationRuleMutation = {
  __typename?: 'Mutation';
  deleteInternalRegulationObligationRule: {
    __typename?: 'InternalRegulationObligationRule';
    id: string;
    name: string;
    obligationId: string;
    reviewStatus?: Types.IInternalRegulationObligationRuleReviewStatus | null;
  };
};

export const DeleteInternalRegulationObligationRuleDocument = gql`
  mutation DeleteInternalRegulationObligationRule($input: DeleteInternalRegulationObligationRuleInput!) {
    deleteInternalRegulationObligationRule(input: $input) {
      id
      name
      obligationId
      reviewStatus
    }
  }
`;
export type IDeleteInternalRegulationObligationRuleMutationFn = Apollo.MutationFunction<
  IDeleteInternalRegulationObligationRuleMutation,
  IDeleteInternalRegulationObligationRuleMutationVariables
>;

/**
 * __useDeleteInternalRegulationObligationRuleMutation__
 *
 * To run a mutation, you first call `useDeleteInternalRegulationObligationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalRegulationObligationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalRegulationObligationRuleMutation, { data, loading, error }] = useDeleteInternalRegulationObligationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInternalRegulationObligationRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteInternalRegulationObligationRuleMutation,
    IDeleteInternalRegulationObligationRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IDeleteInternalRegulationObligationRuleMutation,
    IDeleteInternalRegulationObligationRuleMutationVariables
  >(DeleteInternalRegulationObligationRuleDocument, options);
}
export type DeleteInternalRegulationObligationRuleMutationHookResult = ReturnType<
  typeof useDeleteInternalRegulationObligationRuleMutation
>;
export type DeleteInternalRegulationObligationRuleMutationResult =
  Apollo.MutationResult<IDeleteInternalRegulationObligationRuleMutation>;
export type DeleteInternalRegulationObligationRuleMutationOptions = Apollo.BaseMutationOptions<
  IDeleteInternalRegulationObligationRuleMutation,
  IDeleteInternalRegulationObligationRuleMutationVariables
>;
